module.exports = __webpack_public_path__ + "static/media/Overjet (sagittal fissure)15.fb68ef75.png";